module.exports = __webpack_public_path__ + "static/img/生命科学研究设备.cde5a8f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/研究领域banner/生命科学研究设备.jpg
// module id = C+9t
// module chunks = 1